import { getAttribute } from "PFCore/helpers/get_attribute";
import { CustomType, CustomTypesAccessLevels, Profile } from "PFTypes";

export const ownProfileCustomTypesAccessLevels = (currentProfile: Profile): CustomTypesAccessLevels =>
  currentProfile?.permissionsGroup?.customTypesAccessLevels?.ownProfile;

export const activityCustomTypesAccessLevels = (
  currentProfile: Profile,
  activityCreator: Profile | null
): CustomTypesAccessLevels => {
  const creatorPermissionsGroupId = getAttribute(activityCreator, "permissionsGroup")?.id;
  const currentProfilePermissionsGroupId = currentProfile.permissionsGroup.id;

  return (
    currentProfile.permissionsGroup.crossGroupPermissions[
      creatorPermissionsGroupId ?? currentProfilePermissionsGroupId
    ]?.activityCustomTypesAccessLevels || {}
  );
};

export const customTypesAccessLevelsAgainstProfile = (
  profile: Profile,
  currentProfile: Profile
): CustomTypesAccessLevels => {
  const pgId = profile?.permissionsGroup?.id;

  return (
    (currentProfile?.id === profile?.id
      ? ownProfileCustomTypesAccessLevels(currentProfile)
      : currentProfile?.permissionsGroup?.crossGroupPermissions?.[pgId]?.profileCustomTypesAccessLevels) || {}
  );
};

export const customTypesForProfile = (
  profile: Profile,
  currentProfile: Profile,
  customTypes: CustomType[]
): CustomType[] => {
  const accessLevels = customTypesAccessLevelsAgainstProfile(profile, currentProfile);
  return (customTypes || []).filter((customType) => accessLevels[customType?.id]);
};

export const customTypesForActivities = (
  currentProfile: Profile,
  customTypes: CustomType[]
): CustomType[] => {
  const accessLevels = activityCustomTypesAccessLevels(currentProfile, null);
  return (customTypes || []).filter((customType) => accessLevels[customType?.id]);
};

export const hasCustomTypeSection = (customType: CustomType, sectionKey: string) =>
  !!customType.sections?.find((section) => section.key === sectionKey);
